import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as LikeIcon } from '../../Icons/Like.svg';
import cl from './card.module.css';
import { toSplitThousand } from '../../Hooks/SplitThousand';
import ModalAddToBasket from '../ModalAddToBasket';
import { ADD_FAVORITE, DELETE_FAVORITE } from '../../Redux/type';

const Card = ({
    title,
    price,
    id,
    article,
    unit,
    style = {},
    media,
    factor = [],
    isPriceFrom = false,
}) => {
    const [activePrice, setActivePrice] = useState(0);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const basket = useSelector((state) => state.basket)?.items ?? [];
    const inBasket = basket?.findIndex((item) => item.id === id) !== -1;

    const favorite = useSelector((state) => state.favorite)?.items ?? [];
    const inFavorite = favorite?.findIndex((item) => item.id === id) !== -1;

    const clickHandler = () => {
        if (inBasket) {
            navigate('/basket');
        } else {
            setOpen(true);
        }
    };

    const handleFavorite = () => {
        if (inFavorite) {
            dispatch({
                type: DELETE_FAVORITE,
                payload: id,
            });
        } else {
            dispatch({
                type: ADD_FAVORITE,
                payload: {
                    id,
                    title,
                    price,
                    article,
                    unit,
                    media,
                },
            });
        }
    };

    return (
        <Col className={cl.card} style={style}>
            <Row className={cl.imgContainer}>
                <Link to={`/product/${id}`}>
                    <img
                        style={{
                            width: '100%',
                        }}
                        alt=""
                        src={media ? media[0]?.path : ''}
                    />
                </Link>
            </Row>
            <Row className={cl.articleContainer}>
                <Col>
                    <Button
                        ghost
                        icon={<LikeIcon />}
                        style={{ padding: 0, width: 30, height: 28 }}
                        className={`${cl.likeIcon} ${
                            inFavorite ? cl.likeIconFilled : ''
                        }`}
                        onClick={handleFavorite}
                    />
                </Col>
                <Col>{article}</Col>
            </Row>
            <Row className={cl.titleContainer}>
                <p className={cl.title}>
                    <Link
                        to={`/product/${id}`}
                        style={{ color: 'var(--primary-black)' }}
                    >
                        {title}
                    </Link>
                </p>
            </Row>
            <Row className={cl.price}>
                <Col>
                    <Col className={cl.priceTitle}>Цена за {unit}</Col>
                    <Row className={cl.priceValue}>
                        <span
                            role="presentation"
                            className={`${
                                activePrice === 0 ? cl.activePrice : ''
                            }`}
                            onClick={() => setActivePrice(0)}
                        >
                            {isPriceFrom ? 'от ' : ''}
                            {toSplitThousand(price[0])}
                        </span>
                        <span>&nbsp;/&nbsp;</span>
                        <span
                            role="presentation"
                            className={`${
                                activePrice === 1 ? cl.activePrice : ''
                            }`}
                            onClick={() => setActivePrice(1)}
                        >
                            {toSplitThousand(price[1])}
                        </span>
                    </Row>
                </Col>
            </Row>
            <Row className={cl.panel}>
                <Button
                    type="primary"
                    className={`${cl.btnPay} ${inBasket && cl.btnActive}`}
                    onClick={() => clickHandler()}
                >
                    В {inBasket ? 'корзине' : 'корзину'}
                </Button>
            </Row>
            {open && (
                <ModalAddToBasket
                    open={open}
                    media={media}
                    setOpen={setOpen}
                    title={title}
                    price={price}
                    activePrice={activePrice}
                    id={id}
                    article={article}
                    unit={unit}
                    factor={factor}
                />
            )}
        </Col>
    );
};

export default Card;
